import React, { Component } from 'react';
import moment from 'moment';



const getPoints = (rectW, h, margin, year, month) => {
  const startDay =  moment([year, month]).day();
  const startWeek = moment([year, month]).week() - 1;

  const x = startWeek * rectW;
  const y = startDay * rectW;

  const sY = h + margin.bottom;
  const diff = startDay > 0 ? rectW : 0;
  const eY = -margin.top;

  return {x, y, sY, diff, eY};
}

const getPath = (rectW, h, margin, year, month) => {
  const p = getPoints(rectW, h, margin, year, month);
  return `M ${p.x}, ${p.sY} V ${p.y} h ${p.diff} V ${p.eY}`;
}



export default class Months extends Component {

  render() {
    const {rectW, h, margin, year, pos_x, pos_y, theme_colors} = this.props;
    
    const path = [...Array(12).keys()].map(month =>
      <path className="month-line"
        key={month}
        stroke={theme_colors.text}
        strokeWidth="1.5px"
        shapeRendering="crispEdges"
        fill="none"
        d={getPath(rectW, h, margin, year, month)}
      />
    );

    const text = [...Array(12).keys()].map(month => {
      const p = getPoints(rectW, h, margin, year, month);
      return (
        <text className="month-text"
          key={month}
          fill={theme_colors.text}
          x={p.x + p.diff + 6}
          y={p.eY + 2}
          fontSize="14px"
          alignmentBaseline="hanging"
        >
          {moment(month + 1, 'M').format('MMM')}
        </text>
      );
    });

    return (<g transform={`translate(${pos_x}, ${pos_y})`}>{path}{text}</g>);
  }
}
